module.exports = __webpack_public_path__ + "assets/chartjs.39af0ffc.svg";